import * as roles from '@/services/AuthService'

export default [
  {
    title: 'Профиль',
    component: require('@/pages/profile/User'),
    name: 'UserProfile',
    path: 'user',
    meta: { role: roles.USER_ROLE }
  },
  {
    title: 'Личные данные',
    component: require('@/pages/profile/PersonalData'),
    name: 'PersonalData',
    path: 'personal-data',
    meta: { role: roles.USER_ROLE }
  },
  {
    title: 'Редактирование курсов',
    component: require('@/pages/profile/CourseManage'),
    name: 'CourseManage',
    path: 'course-manage',
    meta: { role: roles.USER_ROLE }
  },
  {
    title: 'Настройка прав',
    component: require('@/pages/profile/RightsManage'),
    name: 'RightsManage',
    path: 'rights',
    meta: { role: roles.ADMIN_ROLE }
  }
]



// WEBPACK FOOTER //
// ./src/data/ProfileSidebarMenu.js